import { Box, Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import PageLayout from '../subcomponents/PageLayout';
import PeriodsTab from './period/PeriodsTab';
import ProgramsTab from './program/ProgramsTab';
import SubprogramsTab from './subprogram/SubprogramsTab';

export default function ProgramManagementPage() {
    const [value, setValue] = useState(0);

    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <PageLayout
            title={resourceFinal[appLanguage].words.MANAGEMENT_PROGRAM}
            content={
                <>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={value} onChange={handleChange}>
                            <Tab label={resourceFinal[appLanguage].words.PROGRAMS} />
                            <Tab label={resourceFinal[appLanguage].words.SUBPROGRAMS} />
                            <Tab label={resourceFinal[appLanguage].words.PERIODS} />
                        </Tabs>
                    </Box>
                    <TabPanel value={value} index={0}>
                        <ProgramsTab />
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <SubprogramsTab />
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        <PeriodsTab />
                    </TabPanel>
                </>
            }
            bottomBar
            fullScreen
        />
    );
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            sx={{ display: value !== index ? 'none' : 'flex', flex: '1 1 auto' }}
        >
            {value === index && (
                <Box sx={{ display: 'flex', flex: '1 1 auto', p: 1 }}>
                    {children}
                </Box>
            )}
        </Box>
    );
};
